import React from 'react'; // It's good practice to import React
import BannerFeaturesList from "./components/BannerFeaturesList";
import Data from "../../data/banner_feature.json";
import BannerWatchVideo from "./components/BannerWatchVideo";

// Helper function to find keywords and wrap them in <a> tags
const createLinks = (text) => {
  const links = {
    'MongoDB': 'https://logicmojo.com/nosql-database',
    'React': 'https://logicmojo.com/what-is-react',
    'Node.js': 'https://nodejs.org/',
    'Javascript': 'https://logicmojo.com/what-is-javascript',
    'Full Stack Developer': 'https://logicmojo.com/full-stack-developer', // Replace # with your link
  };
  
  // Sort keywords by length (desc) to match longer phrases first, e.g., "Full Stack Developer" before "React"
  const sortedKeywords = Object.keys(links).sort((a, b) => b.length - a.length);
  const regex = new RegExp(`(${sortedKeywords.join('|')})`, 'g');
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, index) =>
        links[part] ? (
          <a href={links[part]} key={index} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        ) : (
          part
        )
      )}
    </>
  );
};

function BannerText() {
  return (
    <div className="banner-ai-text mb-4">
      <h1 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }} >Full Stack Developer Course by Logicmojo</h1>
      <div className="hero-event-lable py-2 px-3 my-4 bg-light rounded d-flex justify-content-between align-items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          style={{width: '1.5rem', height: '1.5rem'}} // Using style for broader compatibility
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
          />
        </svg>
        <p className="p-0 m-0 text-dark">Next Batch Starting On 17th March</p>
      </div>
      <BannerWatchVideo ytUrl="https://www.youtube.com/embed/3FKBcKMRx_g" />
      {/* MINIMAL CHANGE IS HERE: We call the createLinks function */}
      {Data.map((data) => (
        <BannerFeaturesList key={data.id} lable={createLinks(data.lable)} />
      ))}
    </div>
  );
}
export default BannerText;

